// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"39746a80","186":"a8222979","796":"8e84162a","954":"cb672c29"}[chunkId] + ".chunk.js";
};